import { FormattedMessage } from "react-intl";
import { displayPopin } from "../../Hook/popins";
import "./adsbanners.css";

function UnderageVerificationBanner() {
  const display = displayPopin();

  return (
    <button
      type="button"
      onClick={() => display("underage")}
      className="insite-ads-banner-card w-full max-w-[320px] rounded-2xl border border-[#dde8ff] bg-gradient-to-r from-[#e8f0ff] via-[#d9ebff] to-[#c8e5ff] px-4 py-3 text-left shadow-[0_18px_40px_rgba(56,119,191,0.22)] transition-transform duration-300 hover:-translate-y-1 sm:max-w-[728px] sm:px-6 sm:py-4"
    >
      <div className="insite-ads-banner-shine" />
      <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex flex-col gap-2 sm:block">
          <p className="text-xs uppercase tracking-[0.35em] text-[#21538c]/80">
            <FormattedMessage
              id="ads_underage_kicker"
              defaultMessage="Safe access"
            />
          </p>
          <h3 className="text-xl font-black text-[#123563] sm:text-3xl">
            <FormattedMessage
              id="ads_underage_title"
              defaultMessage="Verify your age and unlock explicit content"
            />
          </h3>
          <p className="text-xs text-[#184271]/90 sm:text-sm">
            <FormattedMessage
              id="ads_underage_body"
              defaultMessage="Quick, secure verification in under 2 minutes."
            />
          </p>
        </div>
        <div className="mt-3 inline-flex items-center gap-2 self-end whitespace-nowrap rounded-full bg-[#123563] px-4 py-2 text-xs font-bold leading-none text-white shadow-sm sm:mt-0 sm:self-center sm:px-5 sm:py-2 sm:text-sm">
          <FormattedMessage
            id="ads_underage_cta"
            defaultMessage="Verify now"
          />
          <span aria-hidden>→</span>
        </div>
      </div>
    </button>
  );
}

export default UnderageVerificationBanner;
